import React from "react";

export default function PrivacyPage() {
  return (
    <div className="page legal-page">
      <section className="page-section legal-hero">
        <p className="eyebrow">Privacy · Data protection</p>
        <h1>Privacy notice.</h1>
        <p className="hero-intro">This notice describes personal-data processing on the public Birdwatcher website operated by Agroadviser Solutions Kft. Last updated: 30 August 2026.</p>
      </section>

      <section className="page-section compact-section policy-stack">
        <article className="policy-block">
          <span>01</span>
          <div>
            <h2>Data controller</h2>
            <p><strong>Agroadviser Solutions Kft.</strong>, registered office: 3700 Kazincbarcika, Rózsa út 57., Hungary; company registration no. 05-09-039444; tax no. 32943805-2-05.</p>
            <p>Privacy contact: <a href="mailto:info@agroadvisor.hu?subject=Privacy">info@agroadvisor.hu</a>.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>02</span>
          <div>
            <h2>Website access and technical logs</h2>
            <p>When the site is requested, hosting and network infrastructure may process standard technical information such as IP address, request time, requested path, response status and user-agent information. This is used to deliver the site, maintain availability, investigate faults and protect the service.</p>
            <p><strong>Legal basis:</strong> legitimate interests under GDPR Article 6(1)(f), specifically secure and reliable operation of the website. Logs are retained only as long as reasonably necessary for operations and security, subject to the configured retention of the hosting provider.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>03</span>
          <div>
            <h2>Contact enquiries</h2>
            <p>The website currently provides direct phone and email contact. The web contact form is intentionally disabled until its AWS endpoint is connected. While disabled, the form does not submit or collect entered data.</p>
            <p>Once enabled, the form will process the information you provide, such as name, email address, company, topic and message, to answer your enquiry. Depending on the request, the legal basis is GDPR Article 6(1)(b) for steps related to a potential contract or Article 6(1)(f) for ordinary professional correspondence.</p>
            <p>Enquiry data may be retained for up to 12 months after the last substantive communication unless a contractual, accounting, legal-claims or statutory retention requirement justifies a longer period.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>04</span>
          <div>
            <h2>Agroadvisor newsletter</h2>
            <p>The newsletter shown in the footer is an Agroadvisor company newsletter, not a Birdwatcher-only mailing list. Signup is currently disabled and no newsletter address is collected through this website. When activated, subscription will require an affirmative consent action and the consent can be withdrawn at any time.</p>
            <p><strong>Legal basis when enabled:</strong> consent under GDPR Article 6(1)(a). Subscription data is retained until consent is withdrawn or the mailing list is discontinued, except for minimal suppression records needed to respect an unsubscribe request.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>05</span>
          <div>
            <h2>Cookies, analytics and external resources</h2>
            <p>The current Birdwatcher site is not intended to use advertising, behavioural tracking or marketing cookies. The visual interface currently requests web fonts from Google Fonts; that request can disclose technical connection data, including IP address, to the font provider. No advertising profile is created by Birdwatcher from this request.</p>
            <p>If analytics, additional third-party content or non-essential cookies are introduced later, this notice and the consent mechanism must be updated before those functions are enabled where consent is legally required.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>06</span>
          <div>
            <h2>Processors and international transfers</h2>
            <p>We may use hosting, cloud, email and infrastructure providers acting as processors where necessary to operate the website and communications. Processor access is limited to the relevant service purpose and governed by contractual data-protection terms.</p>
            <p>If personal data is transferred outside the European Economic Area, an applicable GDPR transfer mechanism and safeguards must be used, such as an adequacy decision or Standard Contractual Clauses where required.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>07</span>
          <div>
            <h2>Your rights</h2>
            <p>Subject to the conditions of the GDPR, you may request access, rectification, erasure, restriction, portability, or object to processing based on legitimate interests. Where processing is based on consent, you may withdraw that consent at any time without affecting earlier lawful processing.</p>
            <p>Send requests to <a href="mailto:info@agroadvisor.hu?subject=Privacy%20request">info@agroadvisor.hu</a>. We may need to verify identity before disclosing or changing personal data.</p>
          </div>
        </article>

        <article className="policy-block">
          <span>08</span>
          <div>
            <h2>Supervisory authority</h2>
            <p>You may lodge a complaint with the Hungarian National Authority for Data Protection and Freedom of Information (NAIH): 1055 Budapest, Falk Miksa utca 9-11.; postal address 1363 Budapest, Pf. 9.; email: ugyfelszolgalat@naih.hu.</p>
          </div>
        </article>
      </section>
    </div>
  );
}
